// extracted by mini-css-extract-plugin
export default {"innerWrapper":"us-z","tooltipWrapper":"vs-z","icon":"ws-z","tooltip":"xs-z","content":"ys-z"};